export default "__VITE_ASSET__BUD_rArD__"